import { HttpClient, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReceiptServiceService {

  constructor(private http: HttpClient) { }


  getTellerReport(tellerId: any,reportType: any,transactionId: any, urlParams?: any) {

    let httpParams = new HttpParams();

    for (var key in urlParams) {
        httpParams = httpParams.append(key, urlParams[key]);
    }

    return this.http.get(`/tellers/${tellerId}/report/${reportType}/${transactionId}`, { params: httpParams, responseType: "blob" })
    .pipe( catchError(error => {
      console.log("Teller report generation failed");
      return of(true)
    }));
  }

    getReportParameterList(report: string) {
        const httpParams = new HttpParams()
            .append('R_reportListing', report)
            .append('parameterType', 'true');
        return this.http.get(`/runreports/FullParameterList`, { params: httpParams });
    }
}
